import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import cx from 'classnames';

import { useGGTheme } from 'hooks/theme/useGGTheme';

import s from './EnergyNavigation.module.css';

type NavItemProps = {
  to: string;
  className?: string;
  children: React.ReactNode;
  newTab?: boolean;
  onClick?: () => void;
  ariaLabel?: string;
};

const EnergyNavItem = ({
  children,
  to,
  className,
  newTab,
  onClick,
  ariaLabel,
}: NavItemProps) => {
  const router = useRouter();

  const { theme } = useGGTheme();
  const paletteName = theme?.palette.name;

  const isCurrent = router.route === to;
  const isHomePage = router.pathname === '/';

  return (
    <li
      className={cx(s.navItem, className, {
        [s.energy]: paletteName === 'Energy' && isHomePage,
      })}
    >
      {isCurrent && <div className={s.navItemCurrent} />}
      {newTab ? (
        <a
          href={to}
          target="_blank"
          rel="noreferrer"
          {...(ariaLabel ? { ariaLabel } : {})}
        >
          {children}
        </a>
      ) : (
        <Link
          className={cx({
            [s.navItemCurrentPage]: isCurrent,
          })}
          onClick={onClick}
          href={to}
          aria-label={ariaLabel}
        >
          {children}
          {isCurrent ? (
            <span className={s.navItemCurrentA11yHidden}>
              {' -  Current location'}
            </span>
          ) : null}
        </Link>
      )}
    </li>
  );
};

export { EnergyNavItem };
